@if (visible) {
<div class="mobile-nav" role="dialog" aria-modal="true">
  <div
    class="mobile-nav__overlay"
    (click)="close.emit()"
    aria-hidden="true"
  ></div>
  <div
    class="mobile-nav__panel"
    [class.mobile-nav__panel--compact]="compact"
    role="navigation"
  >
    <header class="mobile-nav__header">
      <div>
        <p class="mobile-nav__eyebrow">{{ "MOBILE_NAV.BRAND" | translate }}</p>
        <h2 class="mobile-nav__title">{{ "MOBILE_NAV.TITLE" | translate }}</h2>
        <p class="mobile-nav__subtitle">
          {{ "MOBILE_NAV.SUBTITLE" | translate }}
        </p>
      </div>
      <!-- Shown only in the compact bar, once the notifications card has scrolled away -->
      @if (notificationsRoute) {
      <button
        type="button"
        class="mobile-nav__compact-bell"
        (click)="navigateTo(notificationsRoute)"
        [attr.aria-label]="'MOBILE_NAV.NOTIFICATIONS' | translate"
      >
        <svg cIcon name="cilBell"></svg>
        @if (notificationCount > 0) {
        <span class="mobile-nav__compact-count">{{ notificationCount }}</span>
        }
      </button>
      }
      <button
        type="button"
        cButton
        variant="ghost"
        class="mobile-nav__close"
        (click)="close.emit()"
        aria-label="Close navigation"
      >
        <c-icon name="cilX"></c-icon>
      </button>
    </header>
    <!-- Who is signed in, and into which business -->
    @if (accountEmail || companyName) {
    <div class="mobile-nav__identity" data-test="mobile-identity">
      @if (logoUrl) {
      <img
        class="mobile-nav__identity-logo"
        appLogoContrast
        crossorigin="anonymous"
        [src]="logoUrl"
        [alt]="companyName"
        (error)="logoUrl = null"
      />
      } @else {
      <span class="mobile-nav__identity-initial" aria-hidden="true">{{
        accountInitial
      }}</span>
      }
      <div class="mobile-nav__identity-copy">
        @if (companyName) {
        <p class="mobile-nav__identity-business">{{ companyName }}</p>
        } @if (accountEmail) {
        <p class="mobile-nav__identity-user">{{ accountEmail }}</p>
        }
      </div>
    </div>
    }
    <div class="mobile-nav__body" (scroll)="onBodyScroll($event)">
      @if (notificationsRoute) {
      <section class="mobile-nav__section">
        <p class="mobile-nav__section-label">
          {{ "MOBILE_NAV.NOTIFICATIONS" | translate }}
        </p>
        <button
          type="button"
          class="mobile-nav__notification"
          (click)="navigateTo(notificationsRoute)"
        >
          <div class="mobile-nav__notification-icon">
            <svg cIcon name="cilBell"></svg>
          </div>
          <div>
            <p class="mobile-nav__notification-title">
              {{ notificationCount || 0 }}
              {{ "MOBILE_NAV.NEW_ALERTS" | translate }}
            </p>
            <p class="mobile-nav__notification-subtitle">
              {{ "MOBILE_NAV.NOTIFICATIONS_HINT" | translate }}
            </p>
          </div>
          <c-icon name="cilChevronRight" class="mobile-nav__chevron"></c-icon>
        </button>
      </section>
      } @if (languageItems.length) {
      <section class="mobile-nav__section">
        <p class="mobile-nav__section-label">
          {{ "MOBILE_NAV.LANGUAGE" | translate }}
        </p>
        <select
          class="mobile-nav__language-select"
          [ngModel]="currentLanguage"
          (ngModelChange)="selectLanguage($event)"
          aria-label="Select language"
        >
          @for (language of languageItems; track language) {
          <option [ngValue]="language.code">
            {{ language.label | translate }}
          </option>
          }
        </select>
      </section>
      }
      <section class="mobile-nav__section">
        <p class="mobile-nav__section-label">
          {{ "MOBILE_NAV.WORKSPACE" | translate }}
        </p>
        <div class="mobile-nav__list">
          @for (item of actionableItems; track item) {
          <button
            type="button"
            class="mobile-nav__item"
            (click)="navigateTo(item.url)"
          >
            @if (item.iconComponent?.name) {
            <span class="mobile-nav__icon">
              <svg cIcon [name]="item.iconComponent.name"></svg>
            </span>
            }
            <span class="mobile-nav__label">{{ item.name }}</span>
            @if (item.badge?.text) {
            <span class="mobile-nav__unread">{{ item.badge?.text }}</span>
            }
            <c-icon name="cilChevronRight" class="mobile-nav__chevron"></c-icon>
          </button>
          }
        </div>
      </section>
      @if (accountItems.length) {
      <section class="mobile-nav__section">
        <p class="mobile-nav__section-label">
          {{ "MOBILE_NAV.ACCOUNT" | translate }}
        </p>
        <div class="mobile-nav__list">
          @for (account of accountItems; track account) {
          <button
            type="button"
            class="mobile-nav__item mobile-nav__item--action"
            (click)="onAccountItemClicked(account)"
            [class.mobile-nav__item--danger]="account.danger"
          >
            @if (account.icon) {
            <span class="mobile-nav__icon">
              <svg cIcon [name]="account.icon"></svg>
            </span>
            }
            <span class="mobile-nav__label">{{
              account.label | translate
            }}</span>
            <c-icon name="cilChevronRight" class="mobile-nav__chevron"></c-icon>
          </button>
          }
        </div>
      </section>
      }
    </div>
  </div>
</div>
}
